export enum DirectoryDomain {
    CTQ = 'ctq.chevrontexaco.qnet',
    CT = 'ct.chevrontexaco.net',
    S01 = 's01.chevron.net',
    S02 = 's02.chevron.net',
    Chevron = 'chevron.onmicrosoft.com',
    ChvCorp = 'chvcorp.onmicrosoft.com'
}